import React from 'react';
export function Footer() {
  return <footer className="bg-black border-t border-line py-8 text-center px-4" data-id="element-125" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-126" data-mp="3ggaovpzpm32t">
        <p className="text-steel text-sm" data-id="element-127" data-mp="3gh3qydnq44em">© 2026 Boxing Coach Ready — All Rights Reserved.</p>
      </div>
    </footer>;
}